import { useCallback, useState } from "react"

import type { InventoryLotReference, InventoryLotWithPallet } from "../types"
import { filterUntestedLots } from "../utils"

interface UseUntestedLotsValidationReturn {
  untestedLots: InventoryLotReference[]
  validateLotsTested: () => boolean
  handleUntestedLotsReset: () => void
}

export const useUntestedLotsValidation = (selectedLots: InventoryLotWithPallet[]): UseUntestedLotsValidationReturn => {
  const [untestedLots, setUntestedLots] = useState<InventoryLotReference[]>([])

  const validateLotsTested = useCallback((): boolean => {
    const untestedBlockingLots = filterUntestedLots(selectedLots)

    if (untestedBlockingLots.length) {
      setUntestedLots(untestedBlockingLots)
      return false
    }

    return true
  }, [selectedLots])

  const handleUntestedLotsReset = useCallback(() => {
    setUntestedLots([])
  }, [])

  return { untestedLots, validateLotsTested, handleUntestedLotsReset }
}
